<template lang="pug">
v-select(
  :items='filteredList '
  @input='$emit("input", $event)'
  @change='$emit("change", $event)'
  v-bind='$attrs'
  v-bind.props='$props'
  item-value='id'
  item-text='name'
)
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import picker from "@/mixins/picker";

export default {
  mixins: [picker],

  props: {
    label: {
      default: "Сайты для публикации"
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },

  created() {
    this.fetch();
  },

  methods: mapActions("dictionary/sites", ["fetch"]),
  computed: {
    filteredList() {
      return this.list.filter(this.filter);
    },
    ...mapGetters("dictionary/sites", ["list"])
  }
};
</script>
